import { render, staticRenderFns } from "./edit-scene.vue?vue&type=template&id=2567529e&scoped=true&"
import script from "./edit-scene.vue?vue&type=script&lang=ts&"
export * from "./edit-scene.vue?vue&type=script&lang=ts&"
import style0 from "./edit-scene.vue?vue&type=style&index=0&id=2567529e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567529e",
  null
  
)

export default component.exports